var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0FBBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.7391 15.1504H20.2591C17.7891 15.1504 15.7891 17.1604 15.7891 19.6204V29.0304C15.7891 31.4904 17.7991 33.5004 20.2591 33.5004H28.7291C31.1991 33.5004 33.1991 31.4904 33.1991 29.0304V19.6204C33.2091 17.1504 31.1991 15.1504 28.7391 15.1504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8517 13.5H22.1517C21.1117 13.5 20.2617 14.34 20.2617 15.38V16.32C20.2617 17.36 21.1017 18.2 22.1417 18.2H26.8517C27.8917 18.2 28.7317 17.36 28.7317 16.32V15.38C28.7417 14.34 27.8917 13.5 26.8517 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseorder);
export default __webpack_public_path__ + "static/media/purchaseorder.7a5cd4d718c49821d5b7ce07c4dfd6bf.svg";
export { ForwardRef as ReactComponent };